<script>
  import {onMount} from 'svelte';
  import * as d3 from 'd3';
  import { BASE_DATA_URL, DEATHS_LINE_COLOR } from '../constants';
  import { buildCacheParam, getLastDate } from '../utils';
  import internationalLineChart from '../charts/internationalLineChart';

  let chartContainer;
  let data;

  onMount(async () => {
    data = await d3.csv(`${BASE_DATA_URL}/international-deaths.csv?d=${buildCacheParam()}`);
    const chart = internationalLineChart()
            .data(data)
            .primaryLineColor(DEATHS_LINE_COLOR)
            .chartId('international-deaths');
    d3.select(chartContainer).call(chart);
  });
</script>

<div class="chart-outer">
  <p class="description">Deaths per million</p>
  <div bind:this={chartContainer} />
</div>
